/**
 * Sollae Cloud - Translation Bundler (index.js)
 * 솔래 클라우드 - 번역 통합 관리 (index.js)
 * 
 * English:
 * - What: The main file to load all translations.
 * - Usage: Imports language JSON files and puts them together for the i18n tool.
 * - Feature Support: Loads English and Korean text.
 * - Why: Helps keep translation files organized in one place.
 * - Linked Files: translations/en.json, translations/ko.json, and i18n.js.
 * - Editing Guide:
 *   - To add a new language (like Japanese), import the JSON file here and add it to the list below.
 * 
 * 한국어:
 * - 역할: i18n을 위한 중앙 번역 로더입니다.
 * - 용도: 특정 언어의 JSON 파일을 임포트하여 VueI18n 인스턴스를 위해 하나의 객체로 통합합니다.
 * - 지원 기능: 영어 및 한국어 번역 문자열의 동적 로딩을 지원합니다.
 * - 필요성: 각각의 번역 파일을 체계적으로 관리하는 동시에 다국어 설정에 통합된 진입점을 제공합니다.
 * - 연결된 파일: translations/en.json, translations/ko.json, 그리고 i18n.js를 연결합니다.
 * - 수정 가이드:
 *   - 새로운 언어(예: 일본어)를 추가하려면 JSON 파일을 여기서 임포트하고 내보내는(export) 객체에 항목을 추가하세요.
 */

import ko from './translations/ko.json';
import en from './translations/en.json';

export default {
  ko,
  en,
};
